import React, { ReactNode, useEffect, useRef, useState } from "react";
import "./Modal.css";

import closeIcon from "../assets/svg/close.svg";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  icon?: string;
  title?: string;
  className?: string;
  children: ReactNode;
  // Автозакрытие через N мс (например, для модалок с ошибками) — опционально.
  autoCloseMs?: number;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  icon,
  title,
  className,
  children,
  autoCloseMs,
}) => {
  const [visible, setVisible] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
    } else {
      const timer = setTimeout(() => setVisible(false), 250);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  // onClose хранится в ref, чтобы пересоздание колбэка родителем на каждый
  // рендер не перезапускало таймер автозакрытия.
  const onCloseRef = useRef(onClose);
  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    if (!isOpen || !autoCloseMs) return;
    const timer = setTimeout(() => onCloseRef.current(), autoCloseMs);
    return () => clearTimeout(timer);
  }, [isOpen, autoCloseMs]);

  if (!visible) return null;

  return (
    <div
      className={`modal-overlay${!isOpen ? " closing" : ""}`}
      onClick={onClose}
    >
      <div
        className={`modal-content ${className || ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          {icon && (
            <svg className="modal-icon" width="24" height="24">
              <use href={icon} />
            </svg>
          )}

          {title && <h2 className="modal-title">{title}</h2>}

          <button
            className="modal-close-button"
            onClick={onClose}
            aria-label="Закрыть"
          >
            <img src={closeIcon} alt="Close icon" />
          </button>
        </div>

        {children}
      </div>
    </div>
  );
};

export default Modal;
